<template>
  <div
    @mouseover="openTooltip"
    class="gf-tooltip"
    :style="{
      '--gf-tooltip-width': width,
      '--gf-tooltip-max-width': maxWidth
    }"
  >
    <div
      v-if="$slots.element"
      class="gf-tooltip__element"
    >
      <slot name="element" />
    </div>
    <div
      v-else-if="elementHtml"
      class="gf-tooltip__element"
      v-html="elementHtml"
    ></div>
    <div
      ref="tooltip"
      v-if="$slots.content"
      class="gf-tooltip__tooltip"
      :class="['-' + position, { '--disable-mobile': !showOnMobileVersion }]"
    >
      <div>
        <slot name="content" />
      </div>
    </div>
    <div
      v-else-if="contentHtml"
      class="gf-tooltip__tooltip"
      v-html="contentHtml"
      :class="'-' + position"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'GfCustomTooltip',
  props: {
    position: {
      type: String,
      default: 'top'
    },
    width: {
      type: String,
      default: 'auto'
    },
    maxWidth: {
      type: String,
      default: '350px'
    },
    elementHtml: {
      type: String,
      default: null
    },
    contentHtml: {
      type: String,
      default: null
    },
    showOnMobileVersion: {
      type: Boolean,
      default: false
    },
    container: {
      type: String,
      // обращаюсь к контейнеру(относительно которого использовать observer) через querySelector(conatiner)
      // помним, если класс, то отправлять '.class_name' и т.д.
      default: 'body'
    },
    ignoreIntersection: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(this.getIntersection);
  },
  beforeDestroy() {
    this.observer.disconnect();
  },

  methods: {
    getIntersection([{ isIntersecting, target, boundingClientRect }]) {
      if (this.ignoreIntersection) return;
      if (isIntersecting) {
        const containerElement = document.querySelector(this.container);
        if (!containerElement) return;

        const containerRect = containerElement.getBoundingClientRect();

        if (boundingClientRect.left < containerRect.left) {
          if (!target.classList.contains('-right')) {
            target.classList.replace('-' + this.position, '-right');
          }
        } else if (boundingClientRect.right > containerRect.right) {
          if (!target.classList.contains('-left')) {
            target.classList.replace('-' + this.position, '-left');
          }
        } else if (boundingClientRect.top < containerRect.top) {
          if (!target.classList.contains('-bottom')) {
            target.classList.replace('-' + this.position, '-bottom');
          }
        } else if (boundingClientRect.bottom > containerRect.bottom) {
          if (!target.classList.contains('-top')) {
            target.classList.replace('-' + this.position, '-top');
          }
        }
      }
    },
    openTooltip() {
      if (this.ignoreIntersection || !this.$refs.tooltip) return;
      this.observer.observe(this.$refs.tooltip);
      this.getIntersection([
        {
          isIntersecting: true,
          target: this.$refs.tooltip,
          boundingClientRect: this.$refs.tooltip.getBoundingClientRect()
        }
      ]);
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-tooltip';

#{$this} {
  position: relative;
  width: max-content;
  --gf-tooltip-arrow-size: 4.3px;
  --gf-tooltip-margin: 7px;

  #{$this}__element {
    cursor: pointer;
  }

  #{$this}__tooltip {
    position: absolute;
    padding: 0.5rem;
    width: var(--gf-tooltip-width);
    border: 1px solid var(--gfd-bg);
    max-width: var(--gf-tooltip-max-width);
    max-height: 500px;
    opacity: 0;
    cursor: default;
    background-color: var(--gfd-bg);
    box-shadow: 0 0 2px 1px var(--gfd-bs);
    border-radius: 5px;
    z-index: 1020;
    pointer-events: none;
    backdrop-filter: saturate(180%) blur(18px);
    transition: clip-path 0.3s ease, opacity 0.3s ease;
    clip-path: inset(0 100% 100% 100% round 5px);

    & > :first-child {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &.--disable-mobile {
      @media screen and (max-width: 767px) {
        display: none;
      }
    }

    &.-top {
      bottom: 100%;
      left: 50%;
      margin-bottom: var(--gf-tooltip-margin);
      transform: translateX(-50%) translateY(3px);
    }

    &.-bottom {
      left: 50%;
      margin-top: var(--gf-tooltip-margin);
      transform: translateX(-50%) translateY(-3px);
    }

    &.-left {
      top: 50%;
      left: calc(-1 * var(--gf-tooltip-margin));
      transform: translateX(calc(-100% + 3px)) translateY(-50%);
    }

    &.-right {
      top: 50%;
      right: calc(-1 * var(--gf-tooltip-margin));
      transform: translateX(calc(100% - 3px)) translateY(-50%);
    }
  }

  #{$this}__element:hover + #{$this}__tooltip,
  #{$this}__tooltip:hover {
    clip-path: inset(-7px -7px -7px -7px round var(--gfd-br, 0.4rem));
    pointer-events: all;
    opacity: 1;
  }

  #{$this}__element:hover + #{$this}__tooltip {
    pointer-events: all;
  }
}
</style>
